import { ClientEffects } from "./client.effects";
import { AuthEffects } from "./auth.effects";
import { PaymentEffects } from "./payment.effects";

export const EFFECTS = [
  AuthEffects,
  ClientEffects,
  PaymentEffects
];



// WEBPACK FOOTER //
// ./src/ngrx/effects/index.ts